import React from "react";
import { Link } from "react-router-dom";
import "./project.css";

const Projects = () => {
    return (
        <div className="container">
            <div className="nav-left nav-left-alt">
                <div className="nav-left-item">
                    <Link to="/work" className="nav-left-link is-black">
                        WORK
                    </Link>
                </div>

                <div className="nav-line is-black"></div>

                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <div className="content content-work">
                <div className="header-mask header-mask-large">
                    <h1 className="header header-large">Sip Und Paint</h1>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="work-container">
                    <div className="description-mask">
                        <p className="description description-large">
                            Painting Services Website with React and Firebase
                            Contact Form.
                        </p>
                    </div>
                    <figure className="w-richtext-figure-type-image w-richtext-align-fullwidth">
                        <div>
                            <img
                                src="https://i.ibb.co/BBPvgjc/sipnpain.jpg"
                                alt="sipnpain"
                            />
                        </div>
                    </figure>
                    <p>
                        This website is a platform that offers professional
                        painting services to customers. Built using React, the
                        website has a clean and modern design that is fully
                        responsive, providing a seamless experience for users on
                        any device.
                        <br />
                    </p>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="content-footer">
                    <blockquote class="call-to-action">
                        Check it out.
                    </blockquote>
                    <a
                        href="https://sipundpaintz.vercel.app/"
                        target="_blank"
                        rel="noreferrer"
                        class="button w-button"
                    >
                        https://sipundpaintz.vercel.app/
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Projects;
